export default {
    ads: [],
    ad: null,
};



// WEBPACK FOOTER //
// ./src/store/modules/ad/state.js